import { useEffect, useState } from "react"
import { useTranslation } from 'hooks/useTranslation'
import { useRouter } from "hooks/useRouter"
import { useAddToCart } from "features/ECommerce/hooks/useAddToCart"
import { useFetchProductDetail } from "features/ECommerce/api/queries/useFetchProductDetail"
import { isElementVisible } from "utils/dom"
import { Loader } from "features/components/Loader"
import heroChicken from '../../../../../../public/assets/product/5lb-chicken-hero.webp'
import heroBeef from '../../../../../../public/assets/product/5lb-beef-hero.webp'
import heroLamb from '../../../../../../public/assets/product/5lb-lamb-hero.webp'
import heroDuck from '../../../../../../public/assets/product/5lb-duck-hero.webp'
import heroVenison from '../../../../../../public/assets/product/5lb-venison-hero.webp'
import heroTurkey from '../../../../../../public/assets/product/5lb-turkey-hero.webp'
import { FivePoundRoot } from "./FivePound.styles"
import { Layout } from "components/Layout"
import { Header } from "components/Header"
import { Hero } from "./components/Hero"
import { Ingredients } from "features/Recipes/FrozenRecipeDetail/components/Ingredients"
import { Recipes } from "features/Recipes/FrozenRecipeDetail/FrozenRecipeDetail"
import { SafetyQuality } from "./components/SafetyQuality"
import { FeedingGuidelines } from "./components/FeedingGuidelines"
import { CustomMealPlan } from "./components/CustomMealPlan"
import { EssentialBox } from "./components/EssentialBox"
import { Compare } from "features/Recipes/components/Compare"
import { Reviews } from "features/Recipes/components/Reviews"
import { Spacer } from "features/Recipes/Recipes.styles"
import { RecipeFooter } from "features/Recipes/components/RecipeFooter"
import { Footer } from "components/Footer"
import { getProteinFromSlug } from "utils/getProteinFromSlug"
import { IngredientType } from "features/Recipes/FrozenRecipeDetail/components/Ingredients/Ingredients"
import { ProductReviewType } from "fixtures/review"
import { StaticImageData } from "next/image"
import { Proteins } from "models/Pet"
import { ProductTypes } from "models/Product"
import { useFetchProducts } from "features/ECommerce/api/queries/useFetchProducts"
import { useFetchShoppingCart } from "features/ECommerce/api/queries/useFetchShoppingCart"

export const FivePound = () => {

    const { t } = useTranslation()
    const { query } = useRouter()
    const addToCart = useAddToCart()
    const header = <Header />

    const thumbnailOptions: Record<Proteins, StaticImageData> = {
      [Proteins.CHICKEN]: heroChicken,
      [Proteins.BEEF]: heroBeef,
      [Proteins.TURKEY]: heroTurkey,
      [Proteins.DUCK]: heroDuck,
      [Proteins.LAMB]: heroLamb,
      [Proteins.VENISON]: heroVenison
    }
  
    const { productId } = query as { productId: string }
    const { data: productDetail, status: statusDetail } = useFetchProductDetail(productId)
    const { data: shoppingCart, status: statusCart } = useFetchShoppingCart({})
    
    const [typesFilter, setTypesFilter] = useState<ProductTypes[]>([])
    const [proteinsFilter, setProteinsFilter] = useState<Proteins[]>([])
    const [querySearch, setQuerySearch] = useState('box')

    const { data: boxes, status: statusBoxes } = useFetchProducts(
      {
        page: 1,
        limit: 10,
        proteins: proteinsFilter,
        types: typesFilter,
        textSearch: querySearch,
      },
      { keepPreviousData: true }
    )

    const [isHidden, setIsHidden] = useState(true)

    const protein = getProteinFromSlug(productId)

  
    useEffect(() => {
      const _scrollListener = () => {
        setIsHidden(false)
  
        const isCTAVisible = isElementVisible('.product-cta')
        const isFooterVisible = isElementVisible('.footer')
  
        if (isCTAVisible || isFooterVisible) {
          setIsHidden(true)
        }
      }
      document.addEventListener('scroll', _scrollListener)
  
      return () => document.removeEventListener('scroll', _scrollListener)
    })

    if (!protein) return <Loader />
    if (statusDetail === 'loading' || statusDetail === 'idle' || statusDetail === 'error') return <Loader />
    if (statusBoxes === 'loading' || statusBoxes === 'idle' || statusBoxes === 'error') return <Loader />
    if (statusCart === 'loading' || statusCart === 'error') return <Loader />

    const ingredients: IngredientType[] = Recipes[protein].ingredients
    const reviews: ProductReviewType[] = Recipes[protein].reviews
    const thumbnail: StaticImageData = thumbnailOptions[protein]

    const isOutOfStock = productDetail.isHidden
    
 return (
    <FivePoundRoot>
      <Layout hideCTA header={header}>
        <Hero shoppingCart={shoppingCart} onAdd={addToCart} product={productDetail} recipe={protein} thumbnail={thumbnail} />
        <Ingredients background="accent-white" hideWave recipe={protein} ingredients={ingredients} />
        <SafetyQuality />
        <FeedingGuidelines />
        <CustomMealPlan />
        <EssentialBox onAdd={addToCart} data={boxes} />
        <Compare background="tertiary-200" />
        <Spacer />
        <Reviews icon cardColor="tertiary-200" background="accent-white" reviews={reviews}/>
        <RecipeFooter ctaLink='/meal-plan' cta={t('products:footer.cta1')} header={t('products:footer.title')}  />
        <Footer />
      </Layout>
    </FivePoundRoot>
 )
}